<script setup lang="ts">
import { Modal } from 'ant-design-vue';
import { ref } from 'vue';
import { useRouterPush } from '@/hooks/common/router';
import { $t } from '@/locales';
import { useAuthStore } from '@/store/modules/auth';
import { useBoolean } from '~/packages/hooks/src';
import ModifyPwdModal from './modify-pwd.vue';
defineOptions({
  name: 'UserAvatar'
});

const authStore = useAuthStore();
const { toLogin } = useRouterPush();
const { bool: modifyPwdVisible, setTrue: showModifyPwdModal } = useBoolean();
// add修改个人信息，copy修改手机号，edit修改密码
const operateType = ref<AntDesign.TableOperateType>('add');

function showModal(type: AntDesign.TableOperateType) {
  operateType.value = type;
  showModifyPwdModal();
}

function loginOrRegister() {
  toLogin();
}

function logout() {
  Modal.confirm({
    title: $t('common.tip'),
    content: $t('common.logoutConfirm'),
    okText: $t('common.confirm'),
    cancelText: $t('common.cancel'),
    onOk: () => {
      authStore.resetStore();
    }
  });
}
</script>

<template>
  <AButton v-if="!authStore.isLogin" @click="loginOrRegister">{{ $t('page.login.common.loginOrRegister') }}</AButton>
  <ADropdown v-else placement="bottomRight" trigger="click">
    <ButtonIcon>
      <SvgIcon icon="ph:user-circle" class="text-icon-large" />
      <span class="text-16px font-medium">{{ authStore.userInfo.name }}</span>
    </ButtonIcon>
    <template #overlay>
      <AMenu>
        <!--
 <AMenuItem @click="routerPushByKey('user-center')">
          <div class="flex-center gap-8px">
            <SvgIcon icon="ph:user-circle" class="text-icon" />
            {{ $t('common.userCenter') }}
          </div>
        </AMenuItem>
        <AMenuDivider />
-->
        <AMenuItem @click="showModal('add')">
          <div class="flex items-center gap-8px">
            <SvgIcon icon="ph:user-gear-light" class="text-icon" />
            {{ $t('common.changeInfo') }}
          </div>
        </AMenuItem>
        <AMenuDivider />
        <AMenuItem @click="showModal('copy')">
          <div class="flex items-center gap-8px">
            <SvgIcon icon="ph:device-mobile-camera" class="text-icon" />
            {{ $t('common.changePhone') }}
          </div>
        </AMenuItem>
        <AMenuDivider />
        <AMenuItem @click="showModal('edit')">
          <div class="flex items-center gap-8px">
            <SvgIcon icon="ph:lock-key" class="text-icon" />
            {{ $t('common.changePassword') }}
          </div>
        </AMenuItem>
        <AMenuDivider />
        <AMenuItem @click="showModal('batch')">
          <div class="flex items-center gap-8px">
            <SvgIcon icon="ph:currency-jpy" class="text-icon" />
            {{ $t('common.withdraw') }}
          </div>
        </AMenuItem>
        <AMenuDivider />
        <AMenuItem @click="logout">
          <div class="flex items-center gap-8px">
            <SvgIcon icon="ph:sign-out" class="text-icon" />
            {{ $t('common.logout') }}
          </div>
        </AMenuItem>
      </AMenu>
    </template>
  </ADropdown>
  <ModifyPwdModal v-model:visible="modifyPwdVisible" :operate-type="operateType" />
</template>

<style scoped></style>
